module.exports = __webpack_public_path__ + "img/F-icon.e0d40756.png";